/**
 * @file 名前分割
 */
'use strict';
// utility class
import Common from '../util/_common';

/**
 * @classname FormNameDivideView
 * @classdesc 名前分割
 */
export default class FormNameDivideView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormNameDivideView.constructor');
		this._$e = $e;
		if($('.user_name').val() !== ''){
			this.init();
		}
	};


	/**
	 * 初期化
	 *
	 * @memberof FormNameDivideView
	 * @return {undefined}
	 */
	init() {
		console.log('FormNameDivideView.init');
		let userName = $('.user_name').val().split(' ');
		let userNameKana = $('.user_name_kana').val().split(' ');
		const userName1 = userName[0];
		const userName2 = userName[1];
		const userNameKana1 = userNameKana[0];
		const userNameKana2 = userNameKana[1];
		$('.user_name1').val(userName1);
		$('.user_name2').val(userName2);
		$('.user_name_kana1').val(userNameKana1);
		$('.user_name_kana2').val(userNameKana2);
	};
}
